import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Pressable, View, Image } from 'react-native';
import { getStatusStripStyles } from './StatusStripWidgetStyles';
import { Avatar, BLACK_600, BLACK_700, BLACK_900, DynamicSvg, Typography, WHITE, checkIsPlatform, getTestId, useBreakpoint } from '@airtel/air-design-system';
export var StatusStripWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'StatusStrip' : _props$testID,
    style = props.style,
    iconName = props.iconName,
    imageUrl = props.imageUrl,
    imageProps = props.imageProps,
    imgStyle = props.imgStyle,
    countContainerStyle = props.countContainerStyle,
    status = props.status,
    onUserAction = props.onUserAction,
    title = props.title,
    subTitle = props.subTitle,
    count = props.count,
    rightIconName = props.rightIconName,
    onStatusStripMetaData = props.onStatusStripMetaData,
    onRightIconPressMetaData = props.onRightIconPressMetaData;
  var statusStripStyles = getStatusStripStyles();
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var handleStatusStripPress = () => {
    onStatusStripMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onStatusStripMetaData), props));
  };
  var onIconActionPress = () => {
    onRightIconPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onRightIconPressMetaData));
  };
  var isWeb = checkIsPlatform('web');
  return _jsx(_Fragment, {
    children: _jsx(Pressable, Object.assign({}, getTestId(testID + "_Pressable"), {
      onPress: handleStatusStripPress
    }, {
      children: _jsxs(View, Object.assign({}, getTestId(testID), {
        style: [statusStripStyles.container, style]
      }, {
        children: [_jsxs(View, Object.assign({
          style: statusStripStyles.iconContainer
        }, {
          children: [iconName && _jsx(Avatar, Object.assign({
            iconName: iconName,
            variant: "icon",
            status: status
          }, getTestId(testID + "_" + iconName))), !!imageUrl && _jsx(Image, Object.assign({
            resizeMode: "contain",
            style: [statusStripStyles.icon, imgStyle],
            source: {
              uri: imageUrl,
              height: isSmallScreen ? 32 : 40,
              width: isSmallScreen ? 32 : 40
            }
          }, imageProps, getTestId(testID, 'imageUrl')))]
        })), _jsxs(View, Object.assign({
          style: statusStripStyles.textContainer
        }, {
          children: [title && _jsx(Typography, {
            type: isWeb ? 'body-para-md-bold' : 'body-para-xs-bold',
            text: title,
            color: BLACK_900
          }), subTitle && _jsx(Typography, {
            type: isWeb ? 'body-para-md' : 'body-para-xs',
            text: subTitle,
            color: BLACK_700
          })]
        })), !!count && _jsx(View, Object.assign({
          style: [statusStripStyles.countContainer, countContainerStyle]
        }, {
          children: _jsx(Typography, {
            type: isWeb ? 'body-para-xs-bold' : 'body-para-xxs-bold',
            text: count > 9 ? '9+' : count.toString(),
            color: WHITE
          })
        })), rightIconName && _jsx(Pressable, Object.assign({
          onPress: onIconActionPress
        }, {
          children: _jsx(DynamicSvg, Object.assign({
            color: BLACK_600,
            iconName: rightIconName
          }, getTestId(testID + "_" + rightIconName)))
        }))]
      }))
    }))
  });
};
StatusStripWidgetComponent.genericRendererKey = 'AirStatusStripWidget';